<template>
  <div id="App">
    <van-nav-bar
      :title="Team.Name == '' ? '新增班组' : Team.Name"
      :left-text="showReturn ? '返回' : ''"
      :left-arrow="showReturn"
      @click-left="onClickLeft"
    />
    <van-form @submit="doSave">
      <van-field
        v-model="teamInfo.TeamName"
        label="班组名称"
        placeholder="班组名称"
        required
        :rules="[{ required: true, message: '请填写班组名称' }]"
      />
      <van-field
        v-model="teamInfo.CorpName"
        label="所在企业"
        placeholder="所在企业"
        required
        :rules="[{ required: true, message: '请选择所在企业' }]"
        readonly
        @click="showSZQY = true"
      />
      <van-field
        v-model="teamInfo.DefWorkerRole"
        label="默认工人类型"
        placeholder="默认工人类型"
        readonly
        @click="showDefWorkerRole = true"
      />
      <van-field
        v-model="teamInfo.DefWorkType"
        label="默认工种"
        placeholder="默认工种"
        readonly
        @click="showGZ = true"
      />
      <van-cell center title="是否上报">
        <template #right-icon>
          <van-switch :value="checked" @input="onInput" size="24" />
        </template>
      </van-cell>
      <van-field
        v-model="teamInfo.TeamSysNo"
        label="班组编号"
        placeholder="提交后自动获取"
        readonly
      />
      <van-row gutter="20" style="margin-top:20px;margin-bottom:50px;">
        <van-col span="2"></van-col>
        <van-col span="20">
          <van-button
            round
            block
            type="danger"
            native-type="submit"
            color="linear-gradient(to right, #ff6034, #ee0a24)"
          >
            提交
          </van-button>
        </van-col>
        <van-col span="2"></van-col>
      </van-row>
    </van-form>
    <van-popup
      v-model="showDefWorkerRole"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择工人类型"
        show-toolbar
        :columns="DefWorkerRolecolumns"
        @confirm="selDefWorkerRole"
        @cancel="showDefWorkerRole = false"
      />
    </van-popup>
    <van-popup
      v-model="showGZ"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择工种"
        show-toolbar
        value-key="SYC_NAME"
        :columns="GZcolumns"
        @confirm="selGZ"
        @cancel="showGZ = false"
      />
    </van-popup>
    <van-popup
      v-model="showSZQY"
      position="bottom"
      :style="{ height: '320px' }"
      round
    >
      <van-picker
        title="选择所在企业"
        show-toolbar
        value-key="SYC_NAME"
        :columns="SZQYcolumns"
        @confirm="selSZQY"
        @cancel="showSZQY = false"
      />
    </van-popup>
    <van-overlay :show="finished">
      <div class="wrapper">
        <van-loading type="spinner" />
      </div>
    </van-overlay>
  </div>
</template>
<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.zz-title {
  color: lightslategray;
  text-align: left;
}
</style>
<script>
import { mapState } from "vuex";
import { Dialog } from "vant";

export default {
  data() {
    return {
      finished: false,
      checked: true,
      Team: {
        Code: "",
        Name: "",
        Pro: {
          Code: "",
          Name: ""
        }
      },
      options: {
        penColor: "#000"
      },
      showReturn: true,
      showDefWorkerRole: false,
      DefWorkerRolecolumns: ["", "建筑工人", "管理人员"],
      showGZ: false,
      GZcolumns: [],
      showSZQY: false,
      SZQYcolumns: [],
      teamInfo: {
        TeamName: "",
        DefWorkerRole: "",
        DefWorkType: "",
        CorpName: "",
        IsUpload: "1",
        TeamSysNo: ""
      }
    };
  },
  computed: {
    ...mapState(["userInfo", "tempQuery"])
  },
  methods: {
    onClickLeft() {
      var that = this;
      that.$router.push({
        path: "/SelWorkerTeam",
        name: "SelWorkerTeam"
      });
    },
    onInput(checked) {
      this.teamInfo.IsUpload = (checked ? "1" : "0");
      this.checked = checked;
    },
    selGZ(value) {
      this.teamInfo.DefWorkType = value.SYC_NAME;
      this.showGZ = false;
    },
    getGRGZ() {
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatWorkType",
            Params: [that.teamInfo.DefWorkerRole, "", that.teamInfo.CorpName]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.GZcolumns = response.data.Table;
          } 
        })
        .catch(error => {
          Dialog({ message: error.message });
        });
    },
    selDefWorkerRole(value) {
      this.showDefWorkerRole = false;
      if (value != this.teamInfo.DefWorkerRole) {
        this.teamInfo.DefWorkerRole = value;
        this.teamInfo.DefWorkType = "";
        this.getGRGZ();
      }
    },
    selSZQY(value) {
      this.showSZQY = false;
      if (value.SYC_NAME != this.teamInfo.CorpName) {
        this.teamInfo.CorpName = value.SYC_NAME;
        this.teamInfo.DefWorkType = "";
        this.getGRGZ();
      }
    },
    doSave() {
      var that = this;
      that.finished = true;
      Dialog.confirm({
        title: "保存提交",
        message: "是否确认提交当前班组信息？"
      })
        .then(() => {
          that
            .$axios({
              method: "post",
              url: "/api/Tool",
              data: {
                Method: "setTeamInfo",
                CODE: that.Team.Code,
                ProCode: that.Team.Pro.Code,
                teamInfo: that.teamInfo,
              },
              headers: {
                Authorization: "Bearer " + that.userInfo.token
              }
            })
            .then(response => {
              if (response.data.status == "200") {
                that.finished = false;
                Dialog({ message: "保存成功" });
              } else {
                Dialog({ message: response.data.msg });
                that.finished = false;
              }
            })
            .catch(error => {
              Dialog({ message: error.message });
              that.finished = false;
            });
          //2.1  判断数据有效性 OK
          //2.2  保存数据到数据库 OK
          //2.3  班组信息上报
          //1.2  根据返回值，提示用户成功或失败
        })
        .catch(() => {
          that.finished = false;
          return;
        });
    },
  },
  created: function() {
    const u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var that = this;
    that.Team = that.tempQuery;
    that.$store.commit("setTempQuery", that.Team.Pro);
    that
      .$axios({
        method: "post",
        url: "/api/Main",
        data: {
          Method: "GetWechatProCorpCode",
          Params: [that.Team.Pro.Code]
        },
        headers: {
          Authorization: "Bearer " + that.userInfo.token
        }
      })
      .then(response => {
        if (response.data.status == "200") {
          that.SZQYcolumns = response.data.Table;
        } else {
          Dialog({ message: response.data.msg });
        }
      })
      .catch(error => {
        Dialog({ message: error.message });
      });
    if (that.Team.Name != "") {
      that
        .$axios({
          method: "post",
          url: "/api/Main",
          data: {
            Method: "GetWechatTeamInfo",
            Params: [that.Team.Code]
          },
          headers: {
            Authorization: "Bearer " + that.userInfo.token
          }
        })
        .then(response => {
          if (response.data.status == "200") {
            that.teamInfo = response.data.Table[0];
            that.checked = that.teamInfo.IsUpload == "1";
            that.getGRGZ();
          } else {
            Dialog({ message: response.data.msg });
          }
        })
        .catch(error => {
          //弹出失败提醒
          Dialog({ message: error.message });
        });
    }
  }
};
</script>
